import { useState } from 'react';
import axios from 'axios';

const useGet = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const get = async (url, token = null, apiType = 'default') => {
    setIsLoading(true);

    const config = {
      headers: {}
    };

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const baseUrl = apiType === 'crixto' 
        ? process.env.REACT_APP_URL_API_CRIXTO 
        : process.env.REACT_APP_URL_API;

    try {
      const response = await axios.get(baseUrl + url, config);
      setError(null);
      
      if(response.data && response.data.data)
        return response.data.data;
      return response.data;

    } catch (err) {
      console.error("Error in useGet:", err);
      if(err.response && err.response.status === 401){
        if (typeof window !== 'undefined' && window.localStorage) {
          localStorage.removeItem("User");
        }
        window.location.reload();
      }
      setError(err.response ? err.response.status : "Network Error");
      return null; 
    } finally {
      setIsLoading(false);
    }
  };

  return { error, isLoading, get };
};

export default useGet;